import { useFormikContext } from 'formik';
import React from 'react';
import { CustomReportModalFormikValues, TYPE_OF_REPORT } from './types';
import { SegmentedControl } from 'lib/components/SegmentedControl';
import { useTranslation } from 'react-i18next';

export const TypeOfReport = () => {
  const { t } = useTranslation();
  const { values, setFieldValue } =
    useFormikContext<CustomReportModalFormikValues>();

  return (
    <>
      <SegmentedControl
        initialValue={values.typeOfReport}
        onChange={newTab =>
          setFieldValue('typeOfReport', newTab as TYPE_OF_REPORT)
        }
        values={[
          {
            value: TYPE_OF_REPORT.RECURRING,
            label: t(TYPE_OF_REPORT.RECURRING),
          },
          {
            value: TYPE_OF_REPORT.STATIC,
            label: t(TYPE_OF_REPORT.STATIC),
          },
        ]}
      />
    </>
  );
};
